import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import $, { get } from 'jquery';
import Modal from "react-modal";
import { withRouter } from '../utils/withRouter';

import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
// import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Home } from '@mui/icons-material';
import { useLocation } from "react-router-dom";

const AdminMobileDrawer = ({ head, userId }) => {
    const history = useNavigate();
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false)
    const [loginAccesslist, setLoginAccesslist] = useState([])

    //toggle model for logout.................................
    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const loadScripts = () => {
        // This array contains all the files/CDNs 
        // const dynamicScripts = [
        //   'js/jquery.sticky.js',
        //   'js/metisMenu.min.js',
        //   'js/metisMenu-active.js',
        //   'js/main.js'
        // ];

        // for (let i = 0; i < dynamicScripts.length; i++) {
        //   const node = document.createElement('script');
        //   node.src = dynamicScripts[i];
        //   node.type = 'text/javascript';
        //   node.async = false;
        //   document.getElementsByTagName('head')[0].appendChild(node);
        // }
    }
    const logout = () => {
        sessionStorage.clear()
        navigate('/')
    }
    useEffect(() => {
        loadScripts();
        setLoginAccesslist(JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'])

    }, []);

    const location = useLocation();

    useEffect(() => {
        const allowedPaths = ["/hallMasterAU"];
        if (!allowedPaths.includes(location.pathname)) {
            sessionStorage.removeItem("ExhibitionHall")
            sessionStorage.removeItem("hallNameHall")
            sessionStorage.removeItem("ExhibitionOtherAreaIDHall")
        }
    }, [location.pathname]);

    const onRedirect = (path) => {
        history.push({ pathname: path, state: { 'isSearchClear': true } });
    }

    const [collapsed, setCollapsed] = useState(true);

    const handleToggleSidebar = () => {
        setCollapsed(!collapsed);
    }

    const getModuleAccess = (ModuleID) => {
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == ModuleID);
        if (moduleAccess) {
            return moduleAccess.ReadAccess;
        } else {
            return false
        }
        return false;
    };

    return (
        <>
            <Modal isOpen={isOpen} onRequestClose={e => toggleModal()}>
                <div className="modal-dialog custom_modal_dialog" >
                    <div className="modal-content confirm-logout
" style={{ borderRadius: '0px' }}>
                        <div class="modal-header">
                            <h5 class="modal-title modal_title_text">Confirm Logout</h5>
                            {/* <button type="button" class="close modal-close" data-dismiss="modal" onClick={this.toggleModal}>&times;</button> */}
                            <button type="button " class="close pop-close text-dark" data-dismiss="modal" onClick={e => toggleModal()} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>

                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3 class="pop_label">Do you really want to logout?</h3>
                                </div>
                            </div>
                        </div>

                        <div class="row ">
                            <div class="col-md-12">
                                <div class="form-group text-right mod-fot">
                                    <a class="btn save_btn del-pop-save" onClick={logout}> Yes</a>
                                    <a class="btn cancel_btn del-pop-cancel" data-dismiss="modal"
                                        style={{ marginLeft: '5px' }} onClick={toggleModal}> No</a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </Modal>
            <div className="sticky">
                <div className="app-sidebar__overlay" data-bs-toggle="sidebar" />
                <div className="" style={{ zIndex: 999 }}>
                    <div className="side-header top-logo-almnt" style={{ width: '214px' }}>
                        <a className="header-brand1 " href="index.html">
                            <img
                                src={`${sessionStorage.getItem('ExhibitionLogoSS')}`}
                                className="header-brand-img light-logo"
                                alt="logo"
                                style={{ width: '40px' }}
                            />
                            <img
                                src={`${sessionStorage.getItem('ExhibitionLogoSS')}`}
                                className="header-brand-img light-logo1"
                                alt="logo"
                                // style={{ width: '110px' }}
                                style={{ width: '100%' }}
                            />
                        </a>
                        {/* LOGO */}
                    </div>
                    <div className="main-sidemenu">
                        <div className="slide-left disabled d-none" id="slide-left">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="#7b8191"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                            >
                                <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" />
                            </svg>
                        </div>
                        <ul className="side-menu top-space" style={{ marginRight: '0px' }}>
                            {/* A - Agent Entry */}

                            {/* D - Dashboard */}
                            {getModuleAccess('1') &&
                                <li className="slide mobile-list">
                                    <Link to='/dashboard' >
                                        <a className="side-menu__item has-link" data-bs-toggle="slide">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true" /> Dashboard
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {getModuleAccess('8') &&
                                <li className="slide mobile-list">
                                    <Link to='/agentlist' >
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Agent Entry
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }
                            {(getModuleAccess('2') || getModuleAccess('3') || getModuleAccess('4') || getModuleAccess('5') || getModuleAccess('6') ||
                                getModuleAccess('7')) &&
                                <li className="slide mobile-list" >
                                    <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                                        className="nav-link side-menu__item"
                                        data-bs-toggle="collapse"
                                        href="#accountsCollapse"
                                        aria-expanded="false"
                                        aria-controls="accountsCollapse"
                                    >
                                        <span className="side-menu__label">
                                            {" "}
                                            <i class="fa fa-angle-right" aria-hidden="true"></i> Accounts
                                        </span>
                                    </a>
                                    <div className="collapse " id="accountsCollapse">
                                        <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                                            {getModuleAccess('2') &&
                                                <li className="slide mobile-list">  <Link to='/agentReceiptList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Agent Receipt
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('7') &&
                                                <li className="slide mobile-list">  <Link to='/ddReturnList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> DD Return
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('7') &&
                                                <li className="slide mobile-list">  <Link to='/accountEntryPassList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Material Entry pass
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('7') &&
                                                <li className="slide mobile-list">  <Link to='/accountExitPassList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Material Exit pass
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('7') &&
                                                <li className="slide mobile-list">  <Link to='/taxinvoiceexhibitors'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Exhibitors
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('5') &&
                                                <li className="slide mobile-list">  <Link to='/ledgerList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Ledger
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('3') &&
                                                <li className="slide mobile-list">  <Link to='/proformalist'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Proforma Invoice list
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('2') &&
                                                <li className="slide mobile-list">  <Link to='/receiptlist'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Receipt
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('2') &&
                                                <li className="slide mobile-list">  <Link to='/refundList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Refund
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('4') &&
                                                <li className="slide mobile-list">  <Link to='/reminderEmails'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Reminder E-Mail
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('7') &&
                                                <li className="slide mobile-list">
                                                    <Link to={'/stallPossessionChecklistList'}>
                                                        <a className="side-menu__item">
                                                            <span className="side-menu__label">
                                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Stall Possession
                                                            </span>
                                                        </a>
                                                    </Link>
                                                </li>
                                            }
                                            {getModuleAccess('29') &&
                                                <li className="slide mobile-list">  <Link to='/accountTally'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Tally
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('6') &&
                                                <li className="slide mobile-list">  <Link to='/taxinvoicelist'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Tax Invoice List
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('2') &&
                                                <li className="slide mobile-list">  <Link to='/visitorReceiptList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Visitor Receipt
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                            {getModuleAccess('6') &&
                                                <li className="slide mobile-list">  <Link to='/visitorTaxInvoiceList'>
                                                    <a className="side-menu__item">
                                                        <span className="side-menu__label">
                                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Visitor Tax Invoice List
                                                        </span>
                                                    </a></Link>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                </li>
                            }

                            {/* C - Circulars */}
                            {getModuleAccess('14') &&
                                <li className="slide mobile-list">
                                    <Link to={'/addcircular'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Circulars
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* D - Daily Routine Checklist */}
                            {getModuleAccess('24') &&
                                <li className="slide mobile-list">
                                    <Link to={'/dailyRoutineChecklistList'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Daily Routine Checklist
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* E - Exhibitors */}
                            {getModuleAccess('9') &&
                                <li className="slide mobile-list">
                                    <Link to={'/exhibitorlist'} >
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Exhibitors
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }
                            {/* F - Features */}
                            {getModuleAccess('21') &&
                                <li className="slide mobile-list">
                                    <Link to={'/features'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Features
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* H - Hotel Enquiry */}
                            {getModuleAccess('35') &&
                                <li className="slide mobile-list">
                                    <Link to={'/hotelEnquiryList'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Hotel Enquiry
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* M - Manage Area */}
                            {getModuleAccess('20') &&
                                <li className="slide mobile-list">
                                    <Link to={'/manageArea'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Manage Area
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* M - Manual Forms Summary */}
                            {getModuleAccess('11') &&
                                <li className="slide mobile-list">
                                    <Link to={'/manualformsummary'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Manual Forms Summary
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {(getModuleAccess('12')) &&
                                <li className="slide mobile-list" >
                                    <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                                        className="nav-link side-menu__item"
                                        data-bs-toggle="collapse"
                                        href="#masters3"
                                        aria-expanded="false"
                                        aria-controls="masters3"
                                    >
                                        <span className="side-menu__label">
                                            {" "}
                                            <i class="fa fa-angle-right" aria-hidden="true"></i> Manual Forms
                                        </span>
                                    </a>
                                    <div className="collapse" id="masters3">
                                        <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                                            {getModuleAccess('12') &&
                                                <>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/airConnectionApplicationAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Air Connection Application
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/brandingOpportunityAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Branding Opportunity And Advertising Form
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/edirectoryAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> E-Directory Approval
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/exhibitorBadgesAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Exhibitor Badges Approval
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/meetingRoomRequestFormAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Meeting Room Request Form
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/powerConnectionAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Power Connection Approval
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/stallDesign_admin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Stall Design Approval
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/visainvitation'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> VA-Exhibitors
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/waterConnectionAdmin'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Water Connection
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                </>
                                            }
                                        </ul>
                                    </div>
                                </li>
                            }
                            {/* {getModuleAccess('13') &&
                <li className="slide mobile-list">
                  <Link to={'/visitorVisaInvitation'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i class="fa fa-angle-right" aria-hidden="true"></i> VA-Visitors
                      </span>
                    </a>
                  </Link>
                </li>
              } */}
                            {/* M - Master */}
                            {getModuleAccess('27') &&
                                <li className="slide mobile-list" >
                                    <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                                        className="nav-link side-menu__item"
                                        data-bs-toggle="collapse"
                                        href="#masterCollapse"
                                        aria-expanded="false"
                                        aria-controls="masterCollapse"
                                    >
                                        <span className="side-menu__label">
                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Master
                                        </span>
                                    </a>
                                    <div className="collapse " id="masterCollapse">
                                        <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                                            <li className="slide mobile-list">  <Link to='/attendeeTypeMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Attendee Type
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/bankDetailsList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Bank Details
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/chapterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Chapters
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/cityMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> City Master
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/ServiceDeliverableMaster'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Deliverable Services
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/exhibitionMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Exhibition
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/gstList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> GST
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/gateMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Gate
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/hallMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Hall
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/industrySegmentMaster'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Industry Segment
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/onlinePresenceList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Online Presence
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/purposeofVisitMaster'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Purpose of Visit
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/roleMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Role
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/stallMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Stall
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/stateMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> State Master
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">  <Link to='/visitorTypeMasterList'>
                                                <a className="side-menu__item">
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Visitor Type
                                                    </span>
                                                </a></Link>
                                            </li>
                                            <li className="slide mobile-list">
                                                <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                                                    className="nav-link side-menu__item"
                                                    data-bs-toggle="collapse"
                                                    href="#manualFormsMasterCollapse"
                                                    aria-expanded="false"
                                                    aria-controls="masterCollapse"
                                                >
                                                    <span className="side-menu__label">
                                                        <i className="fa fa-angle-right" aria-hidden="true"></i> Manual forms Master
                                                    </span>
                                                </a>
                                                <div className="collapse " id="manualFormsMasterCollapse">
                                                    <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                                                        <li className="slide mobile-list">  <Link to='/additionalFurnitureMaster'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Additional Furniture
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/brandingOpportunityMaster'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Branding Opportunity
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/cateringServicesMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Catering Services
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/delegateMeetingMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Delegate Meeting
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/hostAndHostessMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Host and Hostess
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/housekeepingApplicationMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Housekeeping Application
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/internetConnectionMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Internet Connection
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/leadRetrivalConnectionMaster'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Lead Retrival connection
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/liquorlicenseMaster'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Liquor License
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/meetingRoomMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Meeting Room
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/prAgencyMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> PR Agency
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/photographyAndVideographyMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Photography And Videography
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/rentalAudioVideoMaster'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Rental Audio & Video
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/securityApplicationMasterList'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Security Application
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                        <li className="slide mobile-list">  <Link to='/visitorMeetingMaster'>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Visitor Meeting
                                                                </span>
                                                            </a></Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            }

                            {/* O - Organizer Tracker */}
                            {getModuleAccess('24') &&
                                <li className="slide mobile-list">
                                    <Link to='/organizerTrackerList'>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Organizer Tracker
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* O - Organizer Routine Tasklist */}
                            {getModuleAccess('24') &&
                                <li className="slide mobile-list">
                                    <Link to={'/dailyRoutineTaskList'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Organizer Routine Tasklist
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }
                            {/* {
                getModuleAccess('36') &&
                <li className="slide mobile-list">
                  <Link to={'/addDelegateCircular'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i class="fa fa-angle-right" aria-hidden="true"></i> Delegate Circulars
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {getModuleAccess('35') &&
                <li className="slide mobile-list" >
                  <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                    className="nav-link side-menu__item"
                    data-bs-toggle="collapse"
                    href="#DelegateMasterCollapse"
                    aria-expanded="false"
                    aria-controls="DelegateMasterCollapse"
                  >
                    <span className="side-menu__label">
                      {" "}
                      <i class="fa fa-angle-right" aria-hidden="true"></i> Delegate Master
                    </span>
                  </a>
                  <div className="collapse " id="DelegateMasterCollapse">
                    <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                      <li className="slide mobile-list">
                        <Link to='/delegateInvitationType'>
                          <a className="side-menu__item"
                          >
                            <span className="side-menu__label">
                              {" "}
                              <i class="fa fa-angle-right" aria-hidden="true"></i> Invitation Type
                            </span>
                          </a></Link>
                      </li>
                      <li className="slide mobile-list">
                        <Link to='/delegateInvitationEventList'>
                          <a className="side-menu__item"
                          >
                            <span className="side-menu__label">
                              {" "}
                              <i class="fa fa-angle-right" aria-hidden="true"></i> Invitation Event
                            </span>
                          </a></Link>
                      </li>
                    </ul>
                  </div>
                </li>
              } */}
                            {/* R - Reports */}
                            {getModuleAccess('15') &&
                                <li className="slide mobile-list">
                                    <Link to={'/reportList'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Reports
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* U - Users */}
                            {getModuleAccess('28') &&
                                <li className="slide mobile-list">
                                    <Link to={'/userList'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Users
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* V - VA-Visitors */}
                            {getModuleAccess('13') &&
                                <li className="slide mobile-list">
                                    <Link to={'/visitorVisaInvitation'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> VA-Visitors
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* V - Visitors */}
                            {getModuleAccess('10') &&
                                <li className="slide mobile-list">
                                    <Link to={'/visitorslist'} >
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Visitors
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }

                            {/* S - Service Partner */}
                            {(getModuleAccess('23')) &&
                                <li className="slide mobile-list" >
                                    <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                                        className="nav-link side-menu__item"
                                        data-bs-toggle="collapse"
                                        href="#masters2"
                                        aria-expanded="false"
                                        aria-controls="masters2"
                                    >
                                        <span className="side-menu__label">
                                            <i className="fa fa-angle-right" aria-hidden="true"></i> Service Partner
                                        </span>
                                    </a>
                                    <div className="collapse " id="masters2">
                                        <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                                            {getModuleAccess('23') &&
                                                <>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/VendorPlan'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Plan and Timeline
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/vendorWorkOrderList'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Scope of work
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                    <li className="slide mobile-list">
                                                        <Link to={'/VendorRegistrationList'}>
                                                            <a className="side-menu__item">
                                                                <span className="side-menu__label">
                                                                    <i className="fa fa-angle-right" aria-hidden="true"></i> Service Partner Registration
                                                                </span>
                                                            </a>
                                                        </Link>
                                                    </li>
                                                </>
                                            }
                                        </ul>
                                    </div>
                                </li>
                            }

                            {/* V - Visitors Circulars */}
                            {getModuleAccess('24') &&
                                <li className="slide mobile-list">
                                    <Link to={'/addVisitorCircular'}>
                                        <a className="side-menu__item">
                                            <span className="side-menu__label">
                                                <i className="fa fa-angle-right" aria-hidden="true"></i> Visitors Circulars
                                            </span>
                                        </a>
                                    </Link>
                                </li>
                            }
                            {/* {getModuleAccess('16') &&
                <li className="slide mobile-list">
                  <Link to={'/fasciaadmin'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i class="fa fa-angle-right" aria-hidden="true"></i> Fascia Approval
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {getModuleAccess('17') &&
                <li className="slide mobile-list">
                  <Link to={'/exhibitorBadgesAdmin'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i class="fa fa-angle-right" aria-hidden="true"></i> Exhibitor Badges Approval
                      </span>
                    </a>
                  </Link>
                </li>
              } */}

                            {/* {getModuleAccess('18') &&
                <li className="slide mobile-list">
                  <Link to={'/edirectoryAdmin'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i class="fa fa-angle-right" aria-hidden="true"></i> E-Directory Approval
                      </span>
                    </a>
                  </Link>
                </li>
              } */}

                            {/* <li className="slide mobile-list">
                <Link to={'/powerreqadmin'}>
                  <a className="side-menu__item"
                  >
                    <span className="side-menu__label">
                      {" "}
                      <i class="fa fa-angle-right" aria-hidden="true"></i> Power Connection Approval
                    </span>
                  </a>
                </Link>
              </li> */}

                            {/* <li className="slide mobile-list" style={{cursor:'pointer'}}   data-toggle="modal" data-target="#logout" onClick={toggleModal}>
                  <a className="side-menu__item"
                   >
                    <span className="side-menu__label">
                      {" "}
                      <i class="fa fa-angle-right" aria-hidden="true"></i> Log Out

                      
                    </span>
                  </a>
              </li> */}

                            {/*  <li class="slide mobile-list">
                          <a class="side-menu__item has-link" data-bs-toggle="slide mobile-list" href="#"><i class="side-menu__icon fe fe-activity "></i><span class="side-menu__label">Survey</span></a>
                      </li> */}
                        </ul>
                        <div className="slide-right" id="slide-right">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="#7b8191"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                            >
                                <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" />
                            </svg>
                        </div>
                    </div>

                    <div className="ps__rail-x" style={{ left: '0', bottom: '0' }}>
                        <div className="ps__thumb-x" tabIndex={0} style={{ left: '0', width: '0' }} />
                    </div>
                    <div className="ps__rail-y" style={{ top: '0', right: '0', height: '625px' }}>
                        <div
                            className="ps__thumb-y"
                            tabIndex={0}
                            style={{ top: '0', height: '554px' }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
export default AdminMobileDrawer;